interface IconProps {
  color?: string
  className?: string
}

export default function BTCIcon({ color, className }: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M15.5 7.75C15.5 12.0312 12 15.5 7.75 15.5C3.46875 15.5 0 12.0312 0 7.75C0 3.5 3.46875 0 7.75 0C12 0 15.5 3.5 15.5 7.75ZM11.0625 6.65625C11.2188 5.625 10.4375 5.0625 9.34375 4.71875L9.6875 3.3125L8.84375 3.09375L8.5 4.46875C8.28125 4.40625 8.0625 4.34375 7.84375 4.3125L8.1875 2.9375L7.3125 2.71875L6.96875 4.125C6.78125 4.0625 6.59375 4.03125 6.4375 4V3.96875L5.25 3.6875L5.03125 4.59375L5.65625 4.75C6 4.84375 6.0625 5.0625 6.03125 5.25L5.65625 6.84375C5.6875 6.84375 5.71875 6.84375 5.75 6.875C5.71875 6.84375 5.6875 6.84375 5.65625 6.84375L5.09375 9.0625C5.0625 9.1875 4.9375 9.34375 4.6875 9.28125C4.71875 9.28125 4.09375 9.125 4.09375 9.125L3.65625 10.0938L4.78125 10.375C4.96875 10.4062 5.1875 10.4688 5.375 10.5312L5.03125 11.9375L5.875 12.1562L6.21875 10.75C6.4375 10.8125 6.6875 10.875 6.90625 10.9375L6.5625 12.3125L7.40625 12.5312L7.75 11.125C9.21875 11.4062 10.2812 11.2812 10.75 9.96875C11.125 8.90625 10.75 8.3125 9.96875 7.90625C10.5312 7.78125 10.9375 7.40625 11.0625 6.65625ZM9.125 9.375C8.84375 10.4375 7.0625 9.875 6.5 9.71875L6.96875 7.84375C7.53125 8 9.375 8.28125 9.125 9.375ZM9.375 6.65625C9.125 7.59375 7.65625 7.125 7.1875 7L7.59375 5.3125C8.09375 5.40625 9.625 5.65625 9.375 6.65625Z"
        fill={color ?? '#CCFF00'}
      />
    </svg>
  )
}
